import AuthGuard from "app/auth/AuthGuard";
import Redirect from "app/auth/Redirect";
import { dashboardRoutes } from "app/views/dashboard/DashboardRoutes";
import {StudentDashboardRoutes} from "app/views/student/StudentDashboardRoutes";
import NotFound from "app/views/sessions/NotFound";
import sessionRoutes from "app/views/sessions/SessionRoutes";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import { commisionRoutes } from "./views/commisions/CommissionsRoutes";
import manageDriversRoutes from "./views/manage-drivers/ManageDriversRoutes";
import manageVehiclesRoutes from "./views/manage-vehicles/ManageVehiclesRoutes";
import manageSmcRoutes from './views/manage-smc/ManageSmcRoutes';
import myschoolRoutes from "./views/my-school/myschoolRoutes";
import SettingsRoutes from "./views/Settings/SettingsRoutes";
import HolidayRoutes from "./views/Holiday/HolidayRoutes";
import MisHolidayRoutes from "./views/MisHoliday/MisHolidayRoutes";
import MyProfileRoutes from "./views/MyProfile/MyProfileRoutes";
import reportsRoutes from "./views/reports/ReportsRoutes";
import TrackCarRoutes from "./views/track_car/TrackCarRoutes";
import LogoutRoutes from "./views/logout/LogoutRoutes";
import ResetAccountRoutes from "./views/reset-account/ResetAccountRoutes";
import feedBackRoutes from "./views/FeedBack/feedbackRoutes";
import ImportSchoolRoutes from "./views/importSchools/ImportSchoolRoutes";

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...dashboardRoutes,
      ...myschoolRoutes,
      ...manageVehiclesRoutes,
      ...manageSmcRoutes,
      ...StudentDashboardRoutes,
      ...manageDriversRoutes,
      ...SettingsRoutes,
      ...HolidayRoutes,
      ...MisHolidayRoutes,
      ...MyProfileRoutes,
      ...reportsRoutes,
      ...commisionRoutes,
      ...TrackCarRoutes,
      ...LogoutRoutes,
      ...ResetAccountRoutes,
      ...feedBackRoutes,
      ...ImportSchoolRoutes,
    ],
  },
  ...sessionRoutes,
  { path: "/", element: <Redirect /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
